import { effect, stop } from '@vue/reactivity'
import { evaluateInScope, assignInScope } from '../component/utils'

export default {

    signature: 'qv-model',

    handle(node, scope) {

        if (node.nodeType !== Node.ELEMENT_NODE) {
            return
        }

        const expression = node.getAttribute(this.signature)

        if (!expression) {
            return
        }

        // 1. Update DOM when scope changes
        const runner = effect(() => {

            const value = evaluateInScope(expression, scope)

            const oldValue = node.type === 'checkbox'
                ? (Array.isArray(value) ? node.checked : !!node.checked)
                : node.value

            if (node.type === 'checkbox') {

                if (Array.isArray(value)) {

                    // Handle array values for checkboxes (multiple selection)
                    node.checked = value.includes(node.value)

                } else {

                    // Handle boolean value for single checkbox
                    node.checked = !!value

                }

            } else if (node.type === 'radio') {
                node.checked = node.value === value
            } else {
                node.value = value ?? ''
            }

            // Trigger events if value has changed
            if (oldValue !== (node.type === 'checkbox' ? node.checked : node.value)) {

                // Dispatch input and change events to ensure any listeners are triggered
                node.dispatchEvent(new Event('input', { bubbles: true }))
                node.dispatchEvent(new Event('change', { bubbles: true }))

            }

        })

        // 2. Update scope when DOM changes
        const updateScope = event => {

            let value = event.target.value

            if (node.type === 'checkbox') {

                const currentValue = evaluateInScope(expression, scope)

                if (Array.isArray(currentValue)) {

                    // Handle array values for checkboxes
                    const checkboxValue = node.value
                    const isChecked = event.target.checked

                    if (isChecked && !currentValue.includes(checkboxValue)) {

                        // Add value to array when checked
                        currentValue.push(checkboxValue)
                        value = [ ...currentValue ]

                    } else if (!isChecked && currentValue.includes(checkboxValue)) {

                        // Remove value from array when unchecked
                        value = currentValue.filter(item => item !== checkboxValue)

                    } else {

                        // No change needed
                        return

                    }

                } else {

                    // Handle boolean value for single checkbox
                    value = event.target.checked

                }

            } else if (node.type === 'number') {
                value = parseFloat(value)
            }

            assignInScope(expression, scope, value)

        }

        node.addEventListener('input', updateScope)
        node.addEventListener('change', updateScope)

        return () => {

            stop(runner)
            node.removeEventListener('input', updateScope)
            node.removeEventListener('change', updateScope)

        }

    },

}
